var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('el-container',{staticStyle:{"min-height":"756px"}},[_c('top-logo'),_c('el-main',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1),_c('el-footer',{staticStyle:{"margin-top":"50px"}},[_c('Footer')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }